import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export function LeadDeleteDialog({ open, onOpenChange, lead, deleteConfirm, setDeleteConfirm, deleteReason, setDeleteReason, deleteLead }) {
  const expected = lead?.contact_name ? `DELETE ${lead.contact_name}` : '';
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="lead-delete-dialog">
        <DialogHeader>
          <DialogTitle>Permanently Delete Lead</DialogTitle>
          <DialogDescription>This removes the lead and linked lead workspace records. Archive instead if you may need the history later.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="rounded-sm border border-red-200 bg-red-50 p-3 text-sm text-red-800" data-testid="lead-delete-warning">This cannot be undone. Type <span className="font-bold">{expected}</span> to confirm.</div>
          <div><Label>Delete Reason</Label><Textarea value={deleteReason} onChange={(event) => setDeleteReason(event.target.value)} placeholder="Duplicate, spam, entered by mistake..." data-testid="lead-delete-reason" /></div>
          <div><Label>Confirmation</Label><Input value={deleteConfirm} onChange={(event) => setDeleteConfirm(event.target.value)} placeholder={expected} data-testid="lead-delete-confirm-input" /></div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="lead-delete-cancel">Cancel</Button>
          <Button type="button" variant="destructive" onClick={deleteLead} disabled={deleteConfirm !== expected} data-testid="lead-delete-confirm-button">Delete Permanently</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}